import { STUDENTASSIGNMENT_STATUS } from '../constants';
import { isDatePassed, timestampToDate } from '../utils';

const dateFormat = 'dd MMM, yyyy HH:mm';
export const useStartScreen = ({ assignmentData, createData, currentTime }) => {
  if (!assignmentData) {
    return {};
  }

  const {
    duration,
    name,
    welcomeScreen: { elements },
    startButtonText,
    startDate,
    dueDate,
    settings: { enableStrictMode } = {}
  } = assignmentData;

  let bannerMessage = null;
  let allowStart = true;
  let isAssignmentCompleted = false;
  let studentAssignmentId = null;
  if (startDate && !isDatePassed({ timestamp: startDate, currentTime })) {
    const startDateString = timestampToDate(startDate, dateFormat);
    bannerMessage = `The start date for this assignment is ${startDateString}. You can start this only after ${startDateString}`;
    allowStart = false;
  } else if (dueDate && isDatePassed({ timestamp: dueDate, currentTime })) {
    const dueDateString = timestampToDate(dueDate, dateFormat);
    bannerMessage = `The due date for this assignment was ${dueDateString}. You can no longer start this assignment.`;
    allowStart = false;
  } else if (enableStrictMode) {
    bannerMessage =
      '⚠️ Strict Mode Enabled. This assignment is in strict mode. Leaving the session or opening a new browser window will submit your progress automatically.';
  }

  if (createData?.status === STUDENTASSIGNMENT_STATUS.COMPLETED) {
    isAssignmentCompleted = true;
    studentAssignmentId = createData._id;
  }

  return { bannerMessage, allowStart, isAssignmentCompleted, studentAssignmentId };
};
